import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MergeDeliveryScheduleMutationVariables = Types.Exact<{
  input: Types.MergeDeliveryScheduleInput;
}>;


export type MergeDeliveryScheduleMutation = { __typename?: 'Mutation', mergeDeliverySchedule: { __typename?: 'DeliverySchedulePayload', deliverySchedule?: { __typename?: 'DeliveryScheduleStateData', tenantId: string, deliveryScheduleId: string, name: string, sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, locationIds: Array<string>, status: Types.DeliveryScheduleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateDeliveryScheduleMutationVariables = Types.Exact<{
  input: Types.ActivateDeliveryScheduleInput;
}>;


export type ActivateDeliveryScheduleMutation = { __typename?: 'Mutation', activateDeliverySchedule: { __typename?: 'DeliverySchedulePayload', deliverySchedule?: { __typename?: 'DeliveryScheduleStateData', tenantId: string, deliveryScheduleId: string, name: string, sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, locationIds: Array<string>, status: Types.DeliveryScheduleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type InactivateDeliveryScheduleMutationVariables = Types.Exact<{
  input: Types.InactivateDeliveryScheduleInput;
}>;


export type InactivateDeliveryScheduleMutation = { __typename?: 'Mutation', inactivateDeliverySchedule: { __typename?: 'DeliverySchedulePayload', deliverySchedule?: { __typename?: 'DeliveryScheduleStateData', tenantId: string, deliveryScheduleId: string, name: string, sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, locationIds: Array<string>, status: Types.DeliveryScheduleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteDeliveryScheduleMutationVariables = Types.Exact<{
  input: Types.DeleteDeliveryScheduleInput;
}>;


export type DeleteDeliveryScheduleMutation = { __typename?: 'Mutation', deleteDeliverySchedule: { __typename?: 'DeliverySchedulePayload', deliverySchedule?: { __typename?: 'DeliveryScheduleStateData', tenantId: string, deliveryScheduleId: string, name: string, sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, locationIds: Array<string>, status: Types.DeliveryScheduleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateDeliveryScheduleLocationsMutationVariables = Types.Exact<{
  input: Types.UpdateDeliveryScheduleLocationsInput;
}>;


export type UpdateDeliveryScheduleLocationsMutation = { __typename?: 'Mutation', updateDeliveryScheduleLocations: { __typename?: 'DeliverySchedulePayload', deliverySchedule?: { __typename?: 'DeliveryScheduleStateData', tenantId: string, deliveryScheduleId: string, name: string, sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, locationIds: Array<string>, status: Types.DeliveryScheduleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const MergeDeliveryScheduleDocument = new TypedDocumentString(`
    mutation MergeDeliverySchedule($input: MergeDeliveryScheduleInput!) {
  mergeDeliverySchedule(input: $input) {
    deliverySchedule {
      ...DeliveryScheduleDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment DeliveryScheduleDetails on DeliveryScheduleStateData {
  tenantId
  deliveryScheduleId
  name
  sunday
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  locationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const ActivateDeliveryScheduleDocument = new TypedDocumentString(`
    mutation ActivateDeliverySchedule($input: ActivateDeliveryScheduleInput!) {
  activateDeliverySchedule(input: $input) {
    deliverySchedule {
      ...DeliveryScheduleDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment DeliveryScheduleDetails on DeliveryScheduleStateData {
  tenantId
  deliveryScheduleId
  name
  sunday
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  locationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const InactivateDeliveryScheduleDocument = new TypedDocumentString(`
    mutation InactivateDeliverySchedule($input: InactivateDeliveryScheduleInput!) {
  inactivateDeliverySchedule(input: $input) {
    deliverySchedule {
      ...DeliveryScheduleDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment DeliveryScheduleDetails on DeliveryScheduleStateData {
  tenantId
  deliveryScheduleId
  name
  sunday
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  locationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const DeleteDeliveryScheduleDocument = new TypedDocumentString(`
    mutation DeleteDeliverySchedule($input: DeleteDeliveryScheduleInput!) {
  deleteDeliverySchedule(input: $input) {
    deliverySchedule {
      ...DeliveryScheduleDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment DeliveryScheduleDetails on DeliveryScheduleStateData {
  tenantId
  deliveryScheduleId
  name
  sunday
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  locationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const UpdateDeliveryScheduleLocationsDocument = new TypedDocumentString(`
    mutation UpdateDeliveryScheduleLocations($input: UpdateDeliveryScheduleLocationsInput!) {
  updateDeliveryScheduleLocations(input: $input) {
    deliverySchedule {
      ...DeliveryScheduleDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment DeliveryScheduleDetails on DeliveryScheduleStateData {
  tenantId
  deliveryScheduleId
  name
  sunday
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  locationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MergeDeliverySchedule: build.mutation<MergeDeliveryScheduleMutation, MergeDeliveryScheduleMutationVariables>({
      query: (variables) => ({ document: MergeDeliveryScheduleDocument, variables })
    }),
    ActivateDeliverySchedule: build.mutation<ActivateDeliveryScheduleMutation, ActivateDeliveryScheduleMutationVariables>({
      query: (variables) => ({ document: ActivateDeliveryScheduleDocument, variables })
    }),
    InactivateDeliverySchedule: build.mutation<InactivateDeliveryScheduleMutation, InactivateDeliveryScheduleMutationVariables>({
      query: (variables) => ({ document: InactivateDeliveryScheduleDocument, variables })
    }),
    DeleteDeliverySchedule: build.mutation<DeleteDeliveryScheduleMutation, DeleteDeliveryScheduleMutationVariables>({
      query: (variables) => ({ document: DeleteDeliveryScheduleDocument, variables })
    }),
    UpdateDeliveryScheduleLocations: build.mutation<UpdateDeliveryScheduleLocationsMutation, UpdateDeliveryScheduleLocationsMutationVariables>({
      query: (variables) => ({ document: UpdateDeliveryScheduleLocationsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMergeDeliveryScheduleMutation, useActivateDeliveryScheduleMutation, useInactivateDeliveryScheduleMutation, useDeleteDeliveryScheduleMutation, useUpdateDeliveryScheduleLocationsMutation } = injectedRtkApi;
